module.exports = __webpack_public_path__ + "img/blockchain_lg.8d84c46f.png";